if (!customElements.get('sticky-product-form')) {
  customElements.define(
    'sticky-product-form',
    class StickyProductForm extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.target = document.querySelector(`#MainProduct-${this.sectionId} product-form`);

        if (!this.target || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('sticky-product-form--visible', scrolledPast);
          },
          { threshold: 0 }
        );
        this.observer.observe(this.target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
